import { render, staticRenderFns } from "./myPromotion.vue?vue&type=template&id=58c2c0e7"
import script from "./myPromotion.vue?vue&type=script&lang=js"
export * from "./myPromotion.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports